import { TABLE_GRID } from 'modules/listIndex/constants';
import { Skeleton } from 'ui/skeleton';
import { LIST_SKELETON_COLUMN_COUNT } from '../../constants';
import { StyledGridRow } from './styles';

export const DATA_TEST_ID = 'list-skeleton-row';

export const ListSkeletonRow = () => {
  return (
    <StyledGridRow data-test={DATA_TEST_ID} gridLayout={TABLE_GRID}>
      {Array(LIST_SKELETON_COLUMN_COUNT)
        .fill({})
        .map((_, i) => (
          <Skeleton height={50} key={i} />
        ))}
    </StyledGridRow>
  );
};

type Props = {
  rowCount: number;
};

export const ListSkeletonRows = ({ rowCount }: Props) => {
  return Array(rowCount)
    .fill({})
    .map((_, i) => <ListSkeletonRow key={`skeleton-${i}`} />);
};
